import React, { useEffect, useState } from "react";
import { Button, Container, Row, Col } from "react-bootstrap";
import { Images } from "./Images";

const Benefits = ({ cmsLits }) => {
  console.log("🚀 ~ Benefits ~ cmsLits:", cmsLits)



  const [value, setValue] = useState()

  const [value1, setValue1] = useState()
  const [value2, setvalue2] = useState()
  const [value3, setvalue3] = useState()
  const [value4, setvalue4] = useState()
  const [value5, setvalue5] = useState()
  const [value6, setvalue6] = useState()


  const [icon1, setIcon1] = useState({ active: true, image: Images.benefitsIcon })
  const [icon2, setIcon2] = useState({ active: false, image: Images.benefitsIcon })
  const [icon3, setIcon3] = useState({ active: false, image: Images.benefitsIcon })
  const [icon4, setIcon4] = useState({ active: false, image: Images.benefitsIcon })
  const [icon5, setIcon5] = useState({ active: false, image: Images.benefitsIcon })
  const [icon6, setIcon6] = useState({ active: false, image: Images.benefitsIcon })


  useEffect(() => {
    if (cmsLits) {
      setValue(cmsLits.find((value) => (value.identifier == 'Benifits')))
      setValue1(cmsLits.find((value) => (value.identifier == 'Benifit1')))
      setvalue2(cmsLits.find((value) => (value.identifier == 'Benifit2')))
      setvalue3(cmsLits.find((value) => (value.identifier == 'Benifit3')))
      setvalue4(cmsLits.find((value) => (value.identifier == 'Benifit4')))
      setvalue5(cmsLits.find((value) => (value.identifier == 'Benifit5')))
      setvalue6(cmsLits.find((value) => (value.identifier == 'Benifit6')))
    }
  }, [cmsLits]);






  return (
    <div className="benefits">
      <Container className="custom_container">
        <div className="header_sec">
          <Row className="mt-0">
            <Col xs={12} md={12} lg={11}>
              <p className="title-txt">
                {/* Our Key <span className="linear-txt">Benefits</span>
                    */}
                {value?.heading}
              </p>
              <p className="paracontent t-grey mb-0">
                {/* In the fast-paced realms of cryptocurrency and forex trading,
                    the advent of advanced intelligence has marked a new era of
                    opportunities and challenges. Entering this dynamic arena in
                    2024, Sector-8 emerges as a pioneering force, dedicated to
                    harnessing the power of to redefine trading strategies and
                    unlock unprecedented potential for traders worldwide. */}
                {value?.content}
              </p>
            </Col>
          </Row>
        </div>

        {/* <div className="row row-cnt"> */}
        {/* <div className="col-12 col-sm-12 col-md-5 col-lg-5 col-xl-4 mb-4 mb-md-0">
            <div className="header_sec">
              <Button className="our_benefitBtn cmn_gradientBtn">
                <span>OUR BENEFITS</span>
              </Button>
            </div>

            <Button className="get_staretedBtn cmn_blueBtn">Get Started</Button>
          </div> */}
        {/* <div className="col-12 col-md-7 col-lg-7 col-xl-8"> */}
        <div className="benefitsrow gridbox">
          {/* {benefits.map((item, index) => {
                return (
                  <div className="col-12 col-sm-6 mb-3 hvr_col" key={index}>
                    <div
                      className={
                        item.active ? "benefits_card active" : "benefits_card"
                      }
                    >
                      <div className="d-flex align-items-center justify-content-center">
                        <div className="title_card">
                          <img src={item.icon} className="img_src" />
                        </div>
                      </div>
                      <div className="content_sec">
                        <p className="des mb-0">{item.des}</p>
                      </div>
                    </div>
                  </div>
                );
              })} */}


          {/* <div className="col-12 col-sm-12 col-lg-6 col-xl-4 mb-4 hvr_col" key={1}> */}
          <div key={1}>
            <div
              className={
                icon1.active ? "benefits_card active" : "benefits_card"
              }
            >
              <div className="benefits_cardinner">
                <div className="title_card">
                  <p className="title_cardhead">{value1?.heading}</p>
                  <img src={icon1.image} className="img_src img-fluid" />
                </div>
                <div className="dottedline"></div>
                <div className="content_sec">
                  <p className="boxnum">01</p>
                  <div className="contentflex">
                    <span className="star">*</span>
                    <p className="des mb-0">{value1?.content}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>


          <div key={2}>
            <div
              className={
                icon2.active ? "benefits_card active" : "benefits_card"
              }
            >
              <div className="benefits_cardinner">
                <div className="title_card">
                  <p className="title_cardhead">{value2?.heading}</p>
                  <img src={icon2.image} className="img_src img-fluid" />
                </div>
                <div className="dottedline"></div>
                <div className="content_sec">
                  <p className="boxnum">02</p>
                  <div className="contentflex">
                    <span className="star">*</span>
                    <p className="des mb-0">{value2?.content}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>


          <div key={3}>
            <div
              className={
                icon3.active ? "benefits_card active" : "benefits_card"
              }
            >
              <div className="benefits_cardinner">
                <div className="title_card">
                  <p className="title_cardhead">{value3?.heading}</p>
                  <img src={icon3.image} className="img_src img-fluid" />
                </div>
                <div className="dottedline"></div>
                <div className="content_sec">
                  <p className="boxnum">03</p>
                  <div className="contentflex">
                    <span className="star">*</span>
                    <p className="des mb-0">{value3?.content}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div key={4}>
            <div
              className={
                icon4.active ? "benefits_card active" : "benefits_card"
              }
            >
              <div className="benefits_cardinner">
                <div className="title_card">
                  <p className="title_cardhead">{value4?.heading}</p>
                  <img src={icon4.image} className="img_src img-fluid" />
                </div>
                <div className="dottedline"></div>
                <div className="content_sec">
                  <p className="boxnum">04</p>
                  <div className="contentflex">
                    <span className="star">*</span>
                    <p className="des mb-0">{value4?.content}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div key={5}>
            <div
              className={
                icon5.active ? "benefits_card active" : "benefits_card"
              }
            >
              <div className="benefits_cardinner">
                <div className="title_card">
                  <p className="title_cardhead">{value5?.heading}</p>
                  <img src={icon5.image} className="img_src img-fluid" />
                </div>
                <div className="dottedline"></div>
                <div className="content_sec">
                  <p className="boxnum">05</p>
                  <div className="contentflex">
                    <span className="star">*</span>
                    <p className="des mb-0">{value5?.content}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>


          <div key={6}>
            <div
              className={
                icon6.active ? "benefits_card active" : "benefits_card"
              }
            >
              <div className="benefits_cardinner">
                <div className="title_card">
                  <p className="title_cardhead">{value6?.heading}</p>
                  <img src={icon6.image} className="img_src img-fluid" />
                </div>
                <div className="dottedline"></div>
                <div className="content_sec">
                  <p className="boxnum">06</p>
                  <div className="contentflex">
                    <span className="star">*</span>
                    <p className="des mb-0">{value6?.content}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>


        </div>
        {/* </div> */}
        {/* </div> */}
      </Container>
      {/* <video
        src={Images.benefitBg_vdo}
        autoPlay
        muted
        loop
        className="img-fluid video_src"
      />
      <div className="overlay_bg" /> */}
    </div>
  );
};

export default Benefits;
